import { EntityType } from '@crew/enums/domain'
import { useTranslation } from '@crew/modules/i18n'
import { FC, memo, useMemo } from 'react'
import { useAppSelector } from 'states/hooks'
import { CrewAiAssistantAvatar } from 'components/elements/crewAiAssistantAvatar/crewAiAssistantAvatar'
import { CrewAvatarSize } from 'components/elements/crewAvatar/crewAvatar'

/**
 * AIアシスタント - スレッドリスト形式の上部に表示するTipsのメッセージアイテム
 */
export const AiAssistantThreadListTipsMessageItem: FC = memo(() => {
  const { t } = useTranslation()

  // 処理対象のAIアシスタントチャンネルのRAG対象を取得
  // aiAssistantWindowのクエリ対象になる情報を取得する
  const aiAssistantChannnelTargetEntity = useAppSelector(
    (state) => state.message.chat.aiAssistantChannel.displayTargetEntity
  )

  // entityTypeによって出力するTipsのメッセージを変更する
  const generateTipsMessageByEntityType = useMemo(() => {
    switch (aiAssistantChannnelTargetEntity?.entityType) {
      case EntityType.Project:
        return t('label.aiAssistantChannelTipsMessageForProject')
      case EntityType.File:
        return t('label.aiAssistantChannelTipsMessageForFile')
      case EntityType.Event:
        return t('label.aiAssistantChannelTipsMessageForEvent')
      case EntityType.Task:
        return t('label.aiAssistantChannelTipsMessageForTask')
      default:
        return ''
    }
  }, [aiAssistantChannnelTargetEntity?.entityType, t])

  return (
    <div className="flex flex-row gap-2 p-2 items-center">
      {/* アバター */}
      <div className="flex-shrink-0">
        <CrewAiAssistantAvatar size={CrewAvatarSize.base} />
      </div>

      {/* Tipsメッセージ */}
      <div>{generateTipsMessageByEntityType}</div>
    </div>
  )
})
